import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { alertActions, userinfoActions } from '../../../store/actions'

import { valid } from '../../../hook/valid'
import history from '../../../route/history'
import * as common from '../../../assets/js/common.js'

const Retire = (props) => {
  const [state, setState] = useState({
    isWtdrYn: false,
    wtdrOp1: false,
    wtdrOp2: false,
    wtdrOp3: false,
    wtdrOp4: false,
    wtdrOp5: false,
    wtdrOp6: false,
    wtdrOp7: false,
  })

  useEffect(() => {
    props.load()
  }, [])

  useEffect(() => {
    if (props.isSearch) {
      props.userInfo.passwd = '' // 비밀번호 초기화...

      // 관리자 테스트시 test : props.userInfo.userPosCd = '01';
      setState({
        ...state,
        ...props.userInfo,
      })
    }
  }, [props.isSearch])

  useEffect(() => {
    if (props.isRetire) {
      // 탈퇴 성공 Alert 후 로그아웃
      localStorage.removeItem('saveId')
      localStorage.removeItem('lastLogin')
      props.success({
        title: '탈퇴성공',
        message: '성공적으로 탈퇴되었습니다.',
        params: {
          type: 'success',
          action: 'authActions',
          method: 'logOut',
          params: '/loginIntro',
        },
      })
    }
  }, [props.isRetire])

  const handleSubmit = (e) => {
    e.preventDefault()

    // 02: 법인관리회원
    if (JSON.parse(localStorage.getItem('user'))?.payload?.userSeCd === '02') {
      props.error({
        title: '관리자 탈퇴불가',
        message: '사업자/단체의 대표자는 탈퇴할 수 없습니다. 고객센터로 문의해주세요.',
      })
      return
    }

    const { isWtdrYn, passwd, wtdrOp1, wtdrOp2, wtdrOp3, wtdrOp4, wtdrOp5, wtdrOp6, wtdrOp7 } = state

    if (props.checkFindInput({ isWtdrYn, pass: passwd })) {
      props.retireUser({ passwd, wtdrOp1, wtdrOp2, wtdrOp3, wtdrOp4, wtdrOp5, wtdrOp6, wtdrOp7 })
    }
  }

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target
    setState({
      ...state,
      [name]: type === 'checkbox' ? checked : value,
    })
  }

  const prePage = (e) => {
    e.preventDefault()
    history.goBack()
  }

  return (
    <div id="contents">
      <form name="form" onSubmit={handleSubmit}>
        <div className="content-header">
          {common.getDeviceType() !== 'MobileApp' && (
            <a className="page-prev" onClick={prePage}>
              뒤로이동
            </a>
          )}
          {/* <!-- mobile --> */}
          <h2>회원탈퇴</h2>
          <div className="breadcrumb">
            <span>Home</span>
            <span>마이페이지</span>
            <em>회원탈퇴</em>
          </div>
        </div>

        <h3 className="h3-tit first" htmlFor="isWtdrYn">
          회원탈퇴 동의 (필수)
        </h3>
        <div className="guide-box">
          <dl className="dlist1">
            <dt>이용안내</dt>
            <dd>한 번 회원탈퇴가 이루어지면 절대 계정을 복구할 수 없습니다.</dd>
            <dd>탈퇴를 하시면, 동시에 회원가입하신 전자계약시스템(sign.utradehub.or.kr) 이용이 불가능합니다.</dd>
          </dl>
        </div>
        <div className="mt5">
          <input type="checkbox" title="탈퇴여부" id="isWtdrYn" name="isWtdrYn" onChange={(e) => handleChange(e)} />
          <em></em>
          <label htmlFor="isWtdrYn">회원탈퇴 약관 동의</label>
        </div>
        <h3 className="h3-tit">비밀번호 입력</h3>
        <p className="required">* 표시는 필수 입력사항입니다.</p>
        <table className="tbl-write">
          <caption>현재 비밀번호 항목으로 구성</caption>
          <colgroup>
            <col className="col1" />
            <col />
          </colgroup>
          <tbody>
            <tr>
              <th scope="row">
                <em className="required"></em> 현재 비밀번호
              </th>
              <td>
                <input type="password" className="form-keyword" id="passwd" name="passwd" onChange={(e) => handleChange(e)} />
              </td>
            </tr>
          </tbody>
        </table>
        <h3 className="h3-tit">전자문서지갑 서비스 이용 중 불편사항을 선택해주세요. (복수선택가능)</h3>
        <div className="check-box">
          <ul className="item-list2">
            <li>
              <input
                type="checkbox"
                id="service1"
                title="서비스다양성/품질불만 회원특혜부족"
                name="wtdrOp1"
                onChange={(e) => handleChange(e)}
              />
              <em></em>
              <label htmlFor="service1">서비스 다양성 / 품질 불만 회원특혜 부족</label>
            </li>
            <li>
              <input type="checkbox" id="service2" title="개인정보 유출 우려" name="wtdrOp2" onChange={(e) => handleChange(e)} />
              <em></em>
              <label htmlFor="service2">개인정보 유출 우려</label>
            </li>
            <li>
              <input type="checkbox" id="service3" title="회원특혜 부족" name="wtdrOp3" onChange={(e) => handleChange(e)} />
              <em></em>
              <label htmlFor="service3">회원특혜 부족</label>
            </li>
            <li>
              <input type="checkbox" id="service4" title="다양성 부족" name="wtdrOp4" onChange={(e) => handleChange(e)} />
              <em></em>
              <label htmlFor="service4">다양성 부족</label>
            </li>
            <li>
              <input type="checkbox" id="service5" title="이용빈도 낮음" name="wtdrOp5" onChange={(e) => handleChange(e)} />
              <em></em>
              <label htmlFor="service5">이용빈도 낮음</label>
            </li>
            <li>
              <input type="checkbox" id="service6" title="기타" name="wtdrOp6" onChange={(e) => handleChange(e)} />
              <em></em>
              <label htmlFor="service6">기타</label>
            </li>
            <li>
              <input type="checkbox" id="service7" title="속도 불만" name="wtdrOp7" onChange={(e) => handleChange(e)} />
              <em></em>
              <label htmlFor="service7">속도 불만</label>
            </li>
          </ul>
        </div>
        <div className="btn-block center">
          <button type="submit" className="btn-primary lg w200">
            탈퇴하기
          </button>
        </div>
      </form>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    userInfo: state.userinfo?.data,
    isSearch: state.userinfo?.isSearch,
    isRetire: state.userinfo?.isRetire,
  }
}

const actionCreators = {
  load: userinfoActions.load,
  checkFindInput: valid.checkFindInput,
  retireUser: userinfoActions.retireUser,
  success: alertActions.success,
  error: alertActions.error,
}

export default connect(mapStateToProps, actionCreators)(Retire)
